import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { PostManageStore } from "../../../Services/StoreHub";
import { toast } from "react-toastify";
import { AddStoreSchema } from "../../../Schena/AddStore";


const AddStore = ({ showAddStore, setShowAddStore, fetchManageStore }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      store_name: "",
      email: "",
      password: "",
      confirm_password: "",

    },

    validationSchema: AddStoreSchema,
    onSubmit: async (values) => {
      try {
        const res = await PostManageStore({
          store_name: values.store_name,
          email: values.email,
          password: values.password,
        });

        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          fetchManageStore();
        } else {
          toast.warn(res?.data?.message);
        }
        setShowAddStore(false);
      } catch (err) {
        throw new Error(err);
      }
    },
  });

  return (
    <div>
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-2xl px-4 py-6 bg-white rounded shadow">
        <p className="text-2xl font-bold text-gray-800 mb-6">Add a New Store</p>

        <form onSubmit={formik.handleSubmit} className="space-y-4">
          <div>
            <label
              className="block text-gray-700 font-medium pb-1"
              htmlFor="store_name"
            >
              Store Name
            </label>
            <input
              type="text"
              id="store_name"
              name="store_name"
              value={formik.values.store_name}
              onChange={formik.handleChange}
              placeholder="Enter store name"
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {formik.touched.store_name && formik.errors.store_name && (
              <p className="text-red-500 text-sm mt-1">
                {formik.errors.store_name}
              </p>
            )}
          </div>

          <div>
            <label
              className="block text-gray-700 font-medium pb-1"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              placeholder="Enter email address"
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-red-500 text-sm mt-1">{formik.errors.email}</p>
            )}
          </div>

          <div>
            <label
              className="block text-gray-700 font-medium pb-1"
              htmlFor="password"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                onChange={formik.handleChange}
                value={formik.values.password}
                placeholder="Create Password"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {formik.touched.password && formik.errors.password && (
              <p className="text-red-500 text-sm mt-1">
                {formik.errors.password}
              </p>
            )}
          </div>

          <div>
            <label
              className="block text-gray-700 font-medium pb-1"
              htmlFor="confirm_password"
            >
              Confirm Password
            </label>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirm_password"
                name="confirm_password"
                value={formik.values.confirm_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Confirm Password"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                tabIndex={-1}
              >
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {formik.touched.confirm_password &&
              formik.errors.confirm_password && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.confirm_password}
                </p>
              )}
          </div>

          <div className="flex space-x-4 pt-6">
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
            >
              Save Store
            </button>
            <button
              type="button"
              onClick={() => setShowAddStore(false)}
              className="border border-blue-600 text-blue-600 px-6 py-2 rounded hover:bg-blue-50 transition"
            >
              Back to Store Hub
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStore;
